import React from "react";
import { Button } from "@/components/ui/button";

// Checkbox multi-select used for skills/software/user-list fields across the app.
// Supports a "Select all" button plus Ctrl/Cmd+A while focused inside the group.
export default function CheckboxGroup({ options, value, onToggle, onSelectAll, testId }) {
  const normalized = options.map((opt) => (typeof opt === "object" ? opt : { value: opt, label: opt }));
  const allSelected = normalized.length > 0 && value.length === normalized.length;
  return (
    <div
      data-testid={testId}
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
          e.preventDefault();
          onSelectAll();
        }
      }}
      className="border border-border rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-primary/30"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] text-muted-foreground">{value.length} of {normalized.length} selected</span>
        <Button type="button" variant="ghost" size="sm" className="h-6 text-[11px]" onClick={onSelectAll}>
          {allSelected ? "Clear all" : "Select all"} <span className="ml-1 text-muted-foreground">(Ctrl+A)</span>
        </Button>
      </div>
      {normalized.length === 0 && <div className="text-xs text-muted-foreground">No options available yet — ask an admin to add some.</div>}
      <div className="flex flex-wrap gap-3">
        {normalized.map((opt) => (
          <label key={opt.value} className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={value.includes(opt.value)} onChange={() => onToggle(opt.value)} className="h-4 w-4" />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
}
